export const ADELPHI_FEINTS_TARGETS = {
  CURRENT_ADELPHI_FEINT: 'currentAdelphiFeint',
  CREATE_ADELPHI_FEINT: 'createAdelphiFeint',
  ADELPHI_FEINTS: 'adelphiFeints',
  UPDATE_ADELPHI_FEINT_BY_ID: 'updateAdelphiFeintById',
  ADELPHI_FEINT_BY_ID: 'adelphiFeintById',
  DELETE_ADELPHI_FEINT: 'deleteAdelphiFeint'
};

export const ADELPHI_FEINTS_DEFAULT_STATE = {
  [ADELPHI_FEINTS_TARGETS.CURRENT_ADELPHI_FEINT]: null,
  [ADELPHI_FEINTS_TARGETS.CREATE_ADELPHI_FEINT]: null,
  [ADELPHI_FEINTS_TARGETS.ADELPHI_FEINTS]: [],
  [ADELPHI_FEINTS_TARGETS.UPDATE_ADELPHI_FEINT_BY_ID]: null,
  [ADELPHI_FEINTS_TARGETS.ADELPHI_FEINT_BY_ID]: null
};
